import GenericButton from "../../../../shared/ui/GenericButton";
import PageTitle from "../../../../shared/ui/PageTitle";
import {useNavigate} from "react-router-dom";

const TestPageTitle = ({title} : {title: string}) => {
    const navigate = useNavigate();

    return (
        <PageTitle
            back={true}
            actions={
                <GenericButton
                    type="close"
                    onClick={() => navigate(-1)}
                />
            }
        >
            Generează test {title}
        </PageTitle>
    )
}

export default TestPageTitle;